module.exports = __webpack_public_path__ + "static/images/gift.bf27e3896ae07030f8d3ea0da9ed7a66.svg";